/**
 * Fightstyle – Custom Mega Menu
 * Desktop: hover/focus open panel; 3-layer left nav + cards. Mobile: fullscreen overlay, panel stack.
 * Single listener root, keyboard (ESC, tab), focus trap on mobile.
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-mega-menu]';
  var DESKTOP_BREAK = 768;
  var MOUSE_LEAVE_DELAY_MS = 120;

  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var desktop = root.querySelector('[data-mega-desktop]');
  var mobile = root.querySelector('[data-mega-mobile]');
  var headerWrapper = document.getElementById('HeaderWrapper');
  var mobilePanels = root.querySelector('[data-mega-mobile-panels]');
  var openMobileBtn = document.querySelector('.js-drawer-open-nav');
  var siteHeaderEl = document.getElementById('SiteHeader');

  var leaveTimer = null;
  var lastOpenTrigger = null;
  var mobilePanelStack = [];

  // Houdt --mega-header-h CSS var gesynchroniseerd met de werkelijke headerhoogte.
  // Dit zorgt dat de dropdown altijd precies onder de header verschijnt,
  // zowel in normaal als sticky/fixed modus.
  function syncHeaderHeight() {
    if (!siteHeaderEl) return;
    var bottom = siteHeaderEl.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--mega-header-h', Math.max(0, bottom) + 'px');
  }

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  document.addEventListener('scroll', syncHeaderHeight, { passive: true });

  function isDesktop() {
    return window.innerWidth > DESKTOP_BREAK;
  }

  function closeDesktop() {
    if (!desktop) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-expanded', 'false');
    if (headerWrapper) headerWrapper.classList.remove('mega-menu-open');
    var triggers = root.querySelectorAll('.mega-trigger');
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    var items = document.querySelectorAll('.mega-nav__item');
    items.forEach(function (i) { i.classList.remove('is-open'); });
    var panels = desktop.querySelectorAll('.mega-panel');
    panels.forEach(function (p) {
      p.removeAttribute('data-active');
      p.setAttribute('hidden', '');
    });
    var subpanels = desktop.querySelectorAll('.mega-panel__subpanel');
    subpanels.forEach(function (s) {
      s.removeAttribute('data-active');
      s.setAttribute('hidden', '');
    });
    var subnavs = desktop.querySelectorAll('.mega-panel__nav-item');
    subnavs.forEach(function (n) {
      n.classList.remove('is-active');
      n.setAttribute('aria-current', 'false');
    });
  }

  function openDesktopPanel(trigger) {
    var handle = trigger.getAttribute('data-mega-trigger');
    if (!handle) return;
    var panel = desktop.querySelector('[data-mega-panel="' + handle + '"]');
    if (!panel) return;
    root.classList.add('is-open');
    if (headerWrapper) headerWrapper.classList.add('mega-menu-open');
    desktop.removeAttribute('aria-hidden');
    var navItem = trigger.closest('.mega-nav__item');
    document.querySelectorAll('.mega-nav__item').forEach(function (i) { i.classList.remove('is-open'); });
    if (navItem) navItem.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    desktop.querySelectorAll('.mega-panel').forEach(function (p) {
      p.removeAttribute('data-active');
      p.setAttribute('hidden', '');
    });
    panel.removeAttribute('hidden');
    panel.setAttribute('data-active', '');
    var firstSub = panel.querySelector('.mega-panel__nav-item');
    var firstSubpanel = panel.querySelector('.mega-panel__subpanel');
    if (firstSub && firstSubpanel) {
      panel.querySelectorAll('.mega-panel__nav-item').forEach(function (n) {
        n.classList.remove('is-active');
        n.setAttribute('aria-current', 'false');
      });
      firstSub.classList.add('is-active');
      firstSub.setAttribute('aria-current', 'true');
      panel.querySelectorAll('.mega-panel__subpanel').forEach(function (s) {
        s.removeAttribute('data-active');
        s.setAttribute('hidden', '');
      });
      firstSubpanel.removeAttribute('hidden');
      firstSubpanel.setAttribute('data-active', '');
    }
  }

  function setActiveSubpanel(subnav) {
    var panel = subnav.closest('.mega-panel');
    if (!panel) return;
    var handle = subnav.getAttribute('data-mega-subnav');
    var subpanelId = subnav.getAttribute('data-mega-subpanel-id');
    var subpanel = subpanelId ? document.getElementById(subpanelId) : panel.querySelector('[data-mega-subpanel="' + handle + '"]');
    if (!subpanel) return;
    panel.querySelectorAll('.mega-panel__nav-item').forEach(function (n) {
      n.classList.remove('is-active');
      n.setAttribute('aria-current', 'false');
    });
    subnav.classList.add('is-active');
    subnav.setAttribute('aria-current', 'true');
    panel.querySelectorAll('.mega-panel__subpanel').forEach(function (s) {
      s.removeAttribute('data-active');
      s.setAttribute('hidden', '');
    });
    subpanel.removeAttribute('hidden');
    subpanel.setAttribute('data-active', '');
  }

  function bindDesktop() {
    if (!desktop) return;
    var zone = headerWrapper || root;
    zone.addEventListener('mouseover', function (e) {
      if (!isDesktop()) return;
      var trigger = e.target.closest('.mega-trigger');
      if (trigger) {
        if (leaveTimer) {
          clearTimeout(leaveTimer);
          leaveTimer = null;
        }
        lastOpenTrigger = trigger;
        openDesktopPanel(trigger);
      }
    });
    zone.addEventListener('mouseenter', function (e) {
      if (!isDesktop()) return;
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
    });
    zone.addEventListener('mouseleave', function (e) {
      if (!isDesktop()) return;
      leaveTimer = setTimeout(function () {
        leaveTimer = null;
        closeDesktop();
      }, MOUSE_LEAVE_DELAY_MS);
    });

    document.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      var trigger = e.target.closest('.mega-trigger');
      if (trigger) {
        e.preventDefault();
        lastOpenTrigger = trigger;
        openDesktopPanel(trigger);
        return;
      }
      var subnav = e.target.closest('[data-mega-subnav]');
      if (subnav && root.contains(e.target)) {
        e.preventDefault();
        setActiveSubpanel(subnav);
      }
    });

    zone.addEventListener('mouseover', function (e) {
      if (!isDesktop()) return;
      var subnav = e.target.closest('[data-mega-subnav]');
      if (subnav && root.contains(subnav)) {
        setActiveSubpanel(subnav);
      }
    });

    document.addEventListener('focusin', function (e) {
      if (!isDesktop()) return;
      var trigger = e.target.closest('.mega-trigger');
      if (trigger) {
        openDesktopPanel(trigger);
        return;
      }
      var inHeaderOrMega = headerWrapper && headerWrapper.contains(e.target);
      if (!inHeaderOrMega && lastOpenTrigger) {
        closeDesktop();
      }
    });
  }

  function openMobile() {
    if (!mobile) return;
    if (window.theme && theme.NavDrawer && typeof theme.NavDrawer.close === 'function') {
      theme.NavDrawer.close();
    }
    mobile.removeAttribute('hidden');
    mobile.setAttribute('data-open', 'true');
    document.body.classList.add('mega-mobile-open');
    if (headerWrapper) headerWrapper.classList.add('mega-menu-open');
    resetMobilePanels();
    trapFocus(mobile);
    if (openMobileBtn) openMobileBtn.setAttribute('aria-expanded', 'true');
  }

  function closeMobile() {
    if (!mobile) return;
    mobile.setAttribute('data-open', 'false');
    mobile.setAttribute('hidden', '');
    document.body.classList.remove('mega-mobile-open');
    if (headerWrapper) headerWrapper.classList.remove('mega-menu-open');
    resetMobilePanels();
    if (openMobileBtn) openMobileBtn.setAttribute('aria-expanded', 'false');
  }

  function resetMobilePanels() {
    if (!mobilePanels) return;
    var panels = mobilePanels.querySelectorAll('.mega-mobile__panel');
    mobilePanelStack = [];
    panels.forEach(function (p, i) {
      p.classList.remove('is-active', 'is-in-stack', 'is-entering', 'is-exiting', 'is-animate');
      p.setAttribute('hidden', '');
      p.style.transform = '';
      p.style.zIndex = '';
      if (i === 0) {
        p.classList.add('is-in-stack');
        p.removeAttribute('hidden');
        p.style.zIndex = '1';
        mobilePanelStack.push(p);
      }
    });
  }

  function showMobilePanel(panel) {
    if (!panel || !mobilePanels) return;
    mobilePanelStack.push(panel);
    var stackLen = mobilePanelStack.length;
    mobilePanelStack.forEach(function (p, i) {
      p.classList.remove('is-entering', 'is-exiting', 'is-animate');
      p.classList.add('is-in-stack');
      p.removeAttribute('hidden');
      p.style.zIndex = String(i + 1);
      p.style.transform = '';
    });
    panel.classList.remove('is-in-stack');
    panel.classList.add('is-entering');
    panel.style.zIndex = String(stackLen + 1);
    panel.removeAttribute('hidden');
    trapFocus(panel);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('is-animate');
      });
    });
    panel.addEventListener('transitionend', function onEnterEnd(e) {
      if (e.propertyName !== 'transform') return;
      panel.classList.remove('is-entering', 'is-animate');
      panel.classList.add('is-in-stack');
      panel.style.transform = '';
    }, { once: true });
  }

  function goBackMobile() {
    if (!mobilePanels || mobilePanelStack.length <= 1) return;
    var active = mobilePanelStack[mobilePanelStack.length - 1];
    mobilePanelStack.pop();
    var prev = mobilePanelStack[mobilePanelStack.length - 1];
    if (!prev) return;
    active.classList.remove('is-in-stack');
    active.classList.add('is-exiting');
    trapFocus(prev);
    requestAnimationFrame(function () {
      active.classList.add('is-animate');
    });
    active.addEventListener('transitionend', function onExitEnd() {
      active.removeEventListener('transitionend', onExitEnd);
      active.classList.remove('is-exiting', 'is-animate');
      active.setAttribute('hidden', '');
      active.style.transform = '';
      active.style.zIndex = '';
    }, { once: true });
  }

  function trapFocus(container) {
    if (!container) return;
    var focusables = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    container.addEventListener('keydown', function trapKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last && last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first && first.focus();
        }
      }
    }, { once: true });
    if (first) first.focus();
  }

  mobile && root.addEventListener('click', function (e) {
    if (isDesktop()) return;
    var closeBtn = e.target.closest('[data-mega-mobile-close]');
    if (closeBtn) {
      e.preventDefault();
      closeMobile();
      return;
    }
    var backBtn = e.target.closest('[data-mega-mobile-back]');
    if (backBtn) {
      e.preventDefault();
      goBackMobile();
      return;
    }
    var trigger = e.target.closest('[data-mega-mobile-trigger]');
    if (trigger) {
      e.preventDefault();
      var targetHandle = trigger.getAttribute('data-mega-mobile-target');
      var parentHandle = trigger.getAttribute('data-mega-mobile-parent');
      var level = trigger.closest('.mega-mobile__panel');
      level = level ? parseInt(level.getAttribute('data-level'), 10) : 0;
      var panels = mobilePanels.querySelectorAll('.mega-mobile__panel');
      var nextPanel = null;
      panels.forEach(function (p) {
        var pParent = p.getAttribute('data-mega-mobile-parent');
        var pSub = p.getAttribute('data-mega-mobile-sub');
        if (level === 0 && pParent === targetHandle && !pSub) {
          nextPanel = p;
        }
        if (level === 1 && pParent === parentHandle && pSub === targetHandle) {
          nextPanel = p;
        }
      });
      if (nextPanel) {
        showMobilePanel(nextPanel);
      }
    }
  });

  if (openMobileBtn) {
    openMobileBtn.addEventListener('click', function (e) {
      if (!isDesktop()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (mobile.getAttribute('data-open') === 'true') {
          closeMobile();
        } else {
          openMobile();
        }
      }
    }, true);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mobile && mobile.getAttribute('data-open') === 'true') {
        closeMobile();
      } else if (root.classList.contains('is-open')) {
        closeDesktop();
      }
    }
  });

  bindDesktop();

  window.MegaMenu = {
    closeDesktop: closeDesktop,
    closeMobile: closeMobile,
    openMobile: openMobile
  };
})();
